<!--
 * @Description: 
 -->
<template>
  <div>
    <list v-if="currentRoute" />
    <router-view />
  </div>
</template>
<script>
import list from './menuList'
export default {
  components: { list },
  data() {
    return { }
  },
  computed: {
    currentRoute () {
      const {path} = this.$route
      if (path === '/menuList') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>